export default __webpack_public_path__ + "static/media/heart.810c2b26.svg";